import { render } from "./ScormContainer.vue?vue&type=template&id=1c60ce5f&scoped=true"
import script from "./ScormContainer.vue?vue&type=script&lang=js"
export * from "./ScormContainer.vue?vue&type=script&lang=js"

import "./ScormContainer.vue?vue&type=style&index=0&id=1c60ce5f&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c60ce5f"]])

export default __exports__